import { useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import Label from "../../../../../components/Label";

type Props = {
  text: string;
};

export default function TextLabel({ text }: Props) {
  const { colors } = useTheme();
  const tailwind = useTailwind();

  return (
    <Label
      name={text}
      textColor={colors.onSurfaceVariant}
      backgroundColor={colors.surfaceVariant}
      style={tailwind("self-end")}
    />
  );
}
